import ReactVisibilitySensor from "react-visibility-sensor";
import { getVisibleSensorAnimation } from "../../utils/utils";

export default function CardGoal({
  imageHeaders = [],
  globalsImages = [],
  borderTexts = [],
  listTexts = [],
} : { imageHeaders : string[], globalsImages : string[], borderTexts : string[], listTexts : string[]}) {
  return (
    <ReactVisibilitySensor partialVisibility>
      {({ isVisible } : any) => (
        <div className="card-goal">
          <img
            src={imageHeaders[0]}
            alt=""
            className="image-global-goal max-w-50-80"
          />
          <div className="flex-row gap-20 flex-wrap mt-20-40">
            {globalsImages.map((global, index) => (
              <img
                key={index}
                className="header-image"
                alt=""
                src={global}
                // style={{ width : "100px"}}
                style={getVisibleSensorAnimation(
                  isVisible,
                  `fade-in-40px 1s ${index * 0.2}s backwards w-100`
                )}
                
              />
            ))}
          </div>
          <div className="padded-separator"></div>
          <img
            src={imageHeaders[1]}
            alt=""
            style={{ width : "200px"}}
            className="image-global-goal max-w-50-80"
          />
          <div className="flex-column gap-20 mt-20-40">
            {borderTexts.map((text, index) => (
              <ReactVisibilitySensor partialVisibility>
                {({ isVisible } : any) => (
                  <p
                    style={getVisibleSensorAnimation(
                      isVisible,
                      `fade-in-40px 1s ${index * 0.35}s backwards`
                    )}
                    key={index}
                    className="bordered-box"
                  >
                    {text}
                  </p>
                )}
              </ReactVisibilitySensor>
            ))}
          </div>
          <div className="padded-separator"></div>
          <img
            src={imageHeaders[2]}
            alt=""
            className="image-global-goal max-w-50-80"
          />
          {/* <ul className="list ">
            <li>Be the “Go-to” bank for ESG in the Kingdom</li>
            <li>Green Loan and Sustainability Linked Loans availability</li>
          </ul> */}
          <ReactVisibilitySensor partialVisibility>
            {({ isVisible } : any) => (
              <ul className="list mt-20-40">
                {listTexts.map((listItem, index) => (
                  <li
                    style={getVisibleSensorAnimation(
                      isVisible,
                      `fade-in-40px 1s ${index * 0.35}s backwards`
                    )}
                    key={index}
                  >
                    {listItem}
                  </li>
                ))}
              </ul>
            )}
          </ReactVisibilitySensor>
        </div>
      )}
    </ReactVisibilitySensor>
  );
}
